module.exports = __webpack_public_path__ + "img/comodo-ssl.470a0d06.svg";